// Accesos de la Gerencia de Operaciones.
//
// La gerente de Operaciones (cargo exacto "GERENTE DE OPERACIONES") ve lo de jefe
// y de fiscal. En las pantallas de fiscal elige un fiscal y trabaja "como" él:
// el interceptor de src/services/api.ts manda la cedula elegida en el header
// X-Actuar-Como-Fiscal y el backend (api-central, api/modulos/gerente_operaciones.py)
// valida el cargo, la ruta y el fiscal, y deja auditadas las escrituras.

export const HEADER_ACTUAR_COMO_FISCAL = "X-Actuar-Como-Fiscal";

const STORAGE_KEY = "gerente_fiscal_actuando";

export const EVENTO_FISCAL_ACTUANDO = "gerente-fiscal-actuando";

export interface FiscalActuando {
  cedula: string;
  nombre: string;
}

// Pantallas de fiscal. Si se agrega una nueva, sumar aca su ruta y en el backend
// (PREFIJOS_ACTUAR_COMO_FISCAL) los prefijos de los endpoints que usa.
const RUTAS_DE_FISCAL = [
  "/gestiones",
  "/asignacionDetalle",
  "/AsignacionDTEdicion",
  "/fiscalizacion",
  "/fiscalizar",
  "/resumenfiscalizacion",
  "/asignacion-recursos",
  "/gestion-errores",
  "/reemplazos-v2",
  "/gestion-marcacion-v2",
  "/gestionMarcacion",
  "/mis-casos",
  "/asignaciones-v2",
  "/relevamiento-operativo",
  "/orden-trabajo",
  "/evaluacion-capacitacion",
  "/historial-capacitacion",
  "/solicitudes-capacitacion",
  "/solicitudes-rrhh",
  "/cierre-diario",
  "/CierreDiario",
];

export const esGerenteDeOperaciones = (cargo?: string | null): boolean =>
  String(cargo || "").trim().toUpperCase() === "GERENTE DE OPERACIONES";

export const esRutaDeFiscal = (pathname: string): boolean =>
  RUTAS_DE_FISCAL.some((ruta) => pathname === ruta || pathname.startsWith(ruta));

export const obtenerFiscalActuando = (): FiscalActuando | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const valor = JSON.parse(raw);
    return valor?.cedula ? { cedula: String(valor.cedula), nombre: String(valor.nombre || "") } : null;
  } catch {
    return null;
  }
};

export const guardarFiscalActuando = (fiscal: FiscalActuando | null) => {
  try {
    if (fiscal) localStorage.setItem(STORAGE_KEY, JSON.stringify(fiscal));
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Sin storage la gerente vuelve a elegir el fiscal; no rompe la app.
  }
  window.dispatchEvent(new CustomEvent(EVENTO_FISCAL_ACTUANDO));
};
